import React from "react";
import { Loading } from "@kitbird/core";
import { useWithdrawalReceipt } from "../../hooks/Provider";
import { StickyTable } from "../../../../../components/Table/Table.style";
import Table from "../../../../../components/Table";
import columns from "../../columns";

const WithdrawalTable = () => {
  const {
    obsRef,
    tableRef,
    meta,
    params,
    setParams,

    dataTrxType,
    selectedRows,
    withdrawalList,
    isFetching,
    isFetchingNextPage,
    handleCheckRow,
    handleCheckAllRows,
    setModalConfig,
  } = useWithdrawalReceipt();

  return (
    <StickyTable ref={tableRef}>
      {isFetching && !isFetchingNextPage
        ? <Loading variant="line" />
        : <Table
          columns={columns(
            meta.total_items,
            selectedRows,
            handleCheckRow,
            handleCheckAllRows,
            setModalConfig,
            dataTrxType,
          )}
          dataSource={withdrawalList}
          onClickRow={handleCheckRow}
          sortConfig={{
            sortType: params.sortType as "ASC" | "DSC" | "DEFAULT",
            sortBy: params.sortBy,
            onSort: (name, type) => {
              setParams((curr) => ({ ...curr, sortBy: name, sortType: type }));
            },
          }}
          footer={
            <>
              {(!isFetching && meta.page < meta.total_pages) && <tfoot ref={obsRef} style={{ height: 5, width: "100%" }} />}
              {isFetchingNextPage && <Loading variant="circular" />}
            </>
          }
        />
      }
    </StickyTable>
  );
};

export default WithdrawalTable;
